import { BuyButtons } from "//basedonloveofficial.com/cdn/shop/t/80/assets/theme.min.js?v=162497389436493968291697436602";

// Extend it
class CustomBuyButtons extends BuyButtons {
  constructor() {
    super(...arguments);

    this.onVariantChanged()
  }

  onVariantChanged() {
    document.addEventListener('variant:change', function(event) {
      const variant = event.detail.variant; // Gives you access to the whole variant details
      const previousVariant = event.detail.previousVariant; // Gives you access to the details of the previously selected variant
      const product = event.detail.product; // Gives you access to the whole product that the variant belongs to
      const form = event.target; // The form that triggers the change

      const addToCartButtonWrapper = this.querySelector('.buy_buttons__submit');
      const bisNotificationButtonWrapper = this.querySelector('.buy_buttons__bis-notification');

      if (!variant.available) {
        addToCartButtonWrapper.classList.add('hidden');
        bisNotificationButtonWrapper.classList.remove('hidden');
      } else {
        addToCartButtonWrapper.classList.remove('hidden');
        bisNotificationButtonWrapper.classList.add('hidden');
      }
    });

  }
}

// Create the custom elements
window.customElements.define('custom-buy-buttons', CustomBuyButtons);


